export default __webpack_public_path__ + "static/media/spider-monkey1.b05f7278.png";